import { ArrowDownIcon, ArrowUpIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline'
import cloneDeep from 'clone-deep'
import { Button, Tooltip } from 'stories/components'
import { confirm } from 'utils'
import { RenderInput } from 'utils/RenderInput'

export const LoanApplicationSignTemplate = ({
  value: data = {},
  onChange: setData,
}: {
  value: Record<string, any>
  onChange: Function
}) => {
  const onChange = (key: string, value: string) => {
    const temp = cloneDeep(data)
    if (key.includes('content')) {
      const index = key.split('.')[1]
      temp['content'][index] = value
    } else temp[key] = value
    setData(temp)
  }

  const onAddClick = () => {
    const temp = cloneDeep(data)
    temp.content.push('')
    setData(temp)
  }

  const onDelete = async (index: number) => {
    const res: any = await confirm(`Are you sure you want to delete this content?`)
    if (res === false) return
    const temp = cloneDeep(data)
    temp.content.splice(index, 1)
    setData(temp)
  }

  const onUpdateOrder = (index: number, direction: number) => {
    const temp = cloneDeep(data)
    const content = temp.content || []
    content.splice(index + direction, 0, content.splice(index, 1)[0])
    temp.content = content
    setData(temp)
  }

  return (
    <div className="relative ml-6">
      {/* <LayoutLoading show={isLoading} /> */}
      <div className="mb-6 relative">
        <div className={`text-section`}>1. Header</div>
        <RenderInput
          input={{
            inputType: 'textarea',
            title: 'Text',
            value: data.header,
            rows: 5,
          }}
          Key="header"
          onChange={(key: string, value: any) => onChange(key, value)}
        />
      </div>
      <div className="mb-6 relative">
        <div className={`text-section flex items-center gap-2`}>
          <span>2. Content</span>
          <Tooltip message="Add a new content">
            <span className="btn-icon" onClick={onAddClick}>
              <PlusIcon className="w-4 h-4" />
            </span>
          </Tooltip>
        </div>
        {data.content?.map((v: string, index: number) => (
          <div className="mb-2" key={index}>
            <RenderInput
              input={{
                inputType: 'textarea',
                title: `Text ${index + 1}`,
                value: v,
                rows: 3,
                additionalElements: (
                  <div className="flex gap-2 items-center">
                    {index != 0 && (
                      <Tooltip message="Move up">
                        <span className="btn-icon" onClick={() => onUpdateOrder(index, -1)}>
                          <ArrowUpIcon className="w-4 h-4" />
                        </span>
                      </Tooltip>
                    )}
                    {index != (data.content?.length || 0) - 1 && (
                      <Tooltip message="Move down">
                        <span className="btn-icon" onClick={() => onUpdateOrder(index, 1)}>
                          <ArrowDownIcon className="w-4 h-4" />
                        </span>
                      </Tooltip>
                    )}
                    <span onClick={() => onDelete(index)} className="cursor-pointer hover:underline decoration-red-600">
                      <div className="btn-icon">
                        <TrashIcon className="w-4 h-4 text-red-600"></TrashIcon>
                      </div>
                    </span>
                  </div>
                ),
              }}
              Key={`content.${index}`}
              onChange={(key: string, value: any) => onChange(key, value)}
            />
          </div>
        ))}
        <Button link onClick={onAddClick}>
          <div className="flex gap-2 items-center">
            <PlusIcon className="w-4 h-4"></PlusIcon> Add Content
          </div>
        </Button>
      </div>
      <div className="mb-6 relative">
        <div className={`text-section`}>3. Footer</div>
        <RenderInput
          input={{
            inputType: 'textarea',
            title: 'Text',
            value: data.footer,
            rows: 5,
          }}
          Key="footer"
          onChange={(key: string, value: any) => onChange(key, value)}
        />
      </div>

      <div className="mb-6 relative">
        <div className={`text-section`}>4. Link of Terms & Conditions</div>
        <RenderInput
          input={{
            inputType: 'text',
            type: 'text',
            title: 'Link',
            value: data.termsConditionslink,
          }}
          Key="termsConditionslink"
          onChange={(key: string, value: any) => onChange(key, value)}
        />
      </div>
    </div>
  )
}
